import React from 'react';
import {Input, Select, Form, Modal, DatePicker,Upload,message,Button,Icon,Col,Row,Drawer,Descriptions,Badge,Statistic} from 'antd';
import moment from 'moment';

const OrderDetail =(props)=>{	
	
	const {onCancel,visible,item} =props
	
	let width = window.innerWidth <768 ? window.innerWidth*0.8 :window.innerWidth*0.35
	return (
	
	<Drawer   title={item.contract_id?<span>合同号:{item.contract_id}</span>:<span>无合同订单</span>}     placement="right"      closable={false}      onClose={onCancel}    visible={visible}  width={width}  >
	<Descriptions title="费用总览" layout="vertical" bordered>		
		<Descriptions.Item label="仓储费用"><Statistic value={item.storage_fee/100} precision={2} valueStyle ={{fontSize:'15px',fontWeight:'bold'}}/> </Descriptions.Item>
		<Descriptions.Item label="运费费用"><Statistic value={item.transport_fee/100} precision={2} valueStyle ={{fontSize:'15px',fontWeight:'bold'}}/> </Descriptions.Item>
		<Descriptions.Item label="其他费用"><Statistic value={item.other_fee/100} precision={2} valueStyle ={{fontSize:'15px',fontWeight:'bold'}}/> </Descriptions.Item>
		<Descriptions.Item label="订单总金额"><Statistic value={item.order_amount/100} precision={2} valueStyle ={{fontSize:'15px',fontWeight:'bold'}}/></Descriptions.Item>		
	  </Descriptions><br/>
	  
	  	<Descriptions title="商品信息" layout="vertical" bordered>		
		<Row><Col span={24}><pre style={{ margin: 0, textAlign: 'left' }}>
                 {JSON.stringify(item.product_info_list,null , 2)}<br/><br/><br/>
                  </pre></Col>				 
                 </Row>
		
	  </Descriptions>
	   
      </Drawer>
	
	)

}


export default OrderDetail;
